<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div class="d-flex justify-content-between align-items-center">
            <h4>Loại văn bản</h4>
            <el-button
              class="btn-back"
              @click="fn_goBack"
              >Quay lại</el-button
            >
          </div>
          <div class="main-body mt-2">
            <div class="main-body-search">
              <!-- Thêm mới loại văn bản -->
              <el-card class="box-card mb-3">
                <el-form
                  ref="formCreateDocumentType"
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  @submit.native.prevent
                  label-width="145px"
                >
                  <b-row class="mb-3">
                    <h5>Thêm mới loại văn bản</h5>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <el-form-item label="Mã loại" prop="code">
                        <el-input
                          type="text"
                          v-model.trim="mData.dataForm.code"
                          placeholder=""
                          clearable
                          ref="code"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <el-form-item label="Tên loại văn bản" prop="name">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.name"
                          placeholder=""
                          clearable
                          ref="name"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <el-form-item label="Chữ viết tắt" prop="short_name">
                        <el-input
                          type="text"
                          v-model.trim="mData.dataForm.short_name"
                          placeholder=""
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col md="12">
                      <el-form-item label="Thứ tự hiển thị" prop="order">
                        <el-input-number
                          v-model.trim="mData.dataForm.order"
                          placeholder=""
                          clearable
                          :min="1"
                          controls-position="right"
                        ></el-input-number>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <div class="text-center mb-0">
                    <el-button
                      v-if="viewMode == 'create'"
                      class="btn-default"
                      @click="fn_submitForm('create')"
                      >Lưu</el-button
                    >
                    <el-button
                      v-if="viewMode == 'update'"
                      class="btn-default"
                      @click="fn_submitForm('update')"
                      >Cập nhật</el-button
                    >
                    <el-button
                      v-if="viewMode == 'update'"
                      class="btn-back"
                      @click="fn_cancelUpdate()"
                      >Hủy</el-button
                    >
                  </div>
                </el-form>
              </el-card>
              <!-- Danh mục loại văn bản -->
              <h5 class="mb-1">Danh mục loại văn bản</h5>
              <div class="main-body-table">
                <el-table
                  :data="mData.tableRules.data"
                  :border="true"
                  style="width: 100%"
                >
                  <el-table-column prop="" label="STT" width="45">
                    <template slot-scope="scope">
                      <div class="text-center">
                        {{ mData.tableRules.offset + scope.$index + 1 }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="Tên loại văn bản"
                    min-width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.name"
                      >
                        <span class="content" slot="reference">{{ scope.row.name }}</span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    prop="type"
                    label="Loại văn bản"
                    align="center"
                    min-width="110"
                  >
                  </el-table-column> -->
                  <el-table-column
                    prop="code"
                    label="Mã loại văn bản"
                    align="center"
                    min-width="300"
                  >
                  </el-table-column>
                  <el-table-column label="Thao tác" align="center">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        plain
                        round
                        @click="fn_handle('update', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_update"
                        type="primary"
                        :disabled="scope.row.is_default"
                      >
                        <i class="far fa-edit"></i>
                      </el-button>
                      <el-button
                        size="mini"
                        plain
                        round
                        @click="fn_handle('delete', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_delete"
                        type="danger"
                        :disabled="scope.row.is_default"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
                  <div class="col-md-4">
                    <!-- <div v-if="mData.tableRules.allowSelect">
                      {{ aLang.c_select }}:
                      {{ mData.tableRules.recordSelected.length }}
                    </div> -->
                  </div>
                  <div class="col-md-8 text-right">
                    <el-pagination
                      @size-change="fn_tableSizeChange"
                      @current-change="fn_tableCurentChange"
                      @prev-click="fn_tablePrevClick"
                      @next-click="fn_tableNextClick"
                      :page-sizes="mData.tableRules.lengthMenu"
                      :page-size="mData.tableRules.limit"
                      :current-page="mData.tableRules.page"
                      background
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="mData.tableRules.total"
                      :pager-count="5"
                    ></el-pagination>
                  </div>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import CategoryManagementModel from "./CategoryManagementModel";
import DocumentCategoryApi from "../../../moduleApi/DocumentCategoryApi";
import { dataMixin } from './mixin/dataMixin'
import { functionMixin } from './mixin/functionMixin'

export default {
  mixins: [dataMixin, functionMixin],
  data() {
    return {
      aLang: LanguageService.lang,
      viewMode: "create",
      mData: {
        moduleName: 'DocumentType',
        tableRules: MethodService.copyObject(
          CategoryManagementModel.tableRules
        ),
        dataForm: MethodService.copyObject(CategoryManagementModel.dataForm),
        validForm: CategoryManagementModel.validForm,
      },
    };
  },
  methods: {
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters +
          (this.mData.tableRules.filters ? "&" : "") + "type=DOC_TYPE",
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-CategoryManagement-" + this.mData.moduleName,
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              // showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {
            // console.log(err);
          });
      }
      const documentCategoryApiRes = await DocumentCategoryApi.list(dataFilter);
      this.mData.tableRules.total = documentCategoryApiRes.meta.total;
      if (documentCategoryApiRes.result && documentCategoryApiRes.result.length > 0) {
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
        this.mData.tableRules.data = documentCategoryApiRes.result;
      } else {
        this.mData.tableRules.data = [];
      }
      if (
          this.mData.tableRules.offset == this.mData.tableRules.total &&
          this.mData.tableRules.page > 1
      ) {
          this.mData.tableRules.page = this.mData.tableRules.page - 1;
          this.mData.tableRules.offset =
            (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
          await this.fn_initTable();
      }
    },

    async fn_getDataById(id) {
      let documentCategoryApiRes = await DocumentCategoryApi.findById(id);
      if (documentCategoryApiRes.result) {
        this.mData.dataForm = documentCategoryApiRes.result;
      }
    },

    fn_submitForm(type) {
      this.$refs["formCreateDocumentType"].validate(async (valid) => {
        if (valid) {
          try {
            let data = this.mData.dataForm;
            data.name = data.name ? data.name.trim() : '';
            data.code = data.code ? data.code.trim() : '';
            data.order = data.order ? data.order : 1;
            data.type = "DOC_TYPE";

            if (type == "create") {
              await DocumentCategoryApi.create(data);
            } else if (type == "update" ) {
              await DocumentCategoryApi.update(data);
            }
            this.fn_resetForm();
            await this.fn_initTable();
            this.viewMode = "create";
          } catch (error) {
            if (error.code == 500 && error.result.messsage == 'Exit a document category with same name') {
              this.$refs.name.focus();
              window.toastr.error('Tên danh mục đã tồn tại');
            } else if (error.code == 500 && error.result.messsage == 'Exit a document category with same code') {
              this.$refs.code.focus();
              window.toastr.error('Mã danh mục đã tồn tại');
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_handle(type, scope, row) {
      if (type == "update") {
        this.viewMode = type;
        this.fn_resetForm();
        this.fn_getDataById(row.id);
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    async fn_delete(id) {
      try {
        await DocumentCategoryApi.delete(id);
        await this.fn_initTable();
        this.fn_cancelUpdate();
        toastr.success('Xóa loại văn bản thành công!')
      } catch (error) {
        if (error.code && error.code == 500) {
          toastr.error(error.detail)
        } else {
          toastr.error('Xóa loại văn bản thất bại!')
        }
      }
    },

    fn_cancelUpdate() {
      this.fn_resetForm();
      this.viewMode = "create";
    },

    fn_resetForm() {
      this.$refs["formCreateDocumentType"].resetFields();
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },

    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
    },

    fn_goBack() {
      this.$router.go(-1);
    }
  },

  async created() {
    await this.fn_hashUrl();
    await this.fn_initTable();
    this.changeBreadCrumb('DocumentType')
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
  .el-input-number__decrease, .el-input-number__increase {
    border: none;
    background: transparent;
    line-height: 20px !important;
  }
}
</style>
